export const DEFAULT_CATEGORIES = [
  { name: 'Geral', color: '#64748b' },
  { name: 'Moradia', color: '#3b82f6' },
  { name: 'Alimentacao', color: '#f59e0b' },
  { name: 'Transporte', color: '#8b5cf6' },
  { name: 'Saude', color: '#10b981' },
  { name: 'Educacao', color: '#06b6d4' },
  { name: 'Lazer', color: '#ec4899' },
  { name: 'Assinaturas', color: '#f97316' },
  { name: 'Outros', color: '#6366f1' },
];

export const CATEGORY_COLORS = [
  '#3b82f6', '#f59e0b', '#10b981', '#ef4444', '#8b5cf6',
  '#ec4899', '#06b6d4', '#f97316', '#6366f1', '#64748b',
];

export function getCategoryColor(categoryName, userCategories = []) {
  const defaultCat = DEFAULT_CATEGORIES.find(c => c.name === categoryName);
  if (defaultCat) return defaultCat.color;

  const customCat = userCategories.find(c => c.name === categoryName);
  if (customCat) return customCat.color;

  return '#64748b';
}
